import { SVGProps } from "react";

export function GlobalIcon({
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={41}
      height={41}
      viewBox={"0 0 41 41"}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <path
        d="M37.0677 20.4926C37.0677 29.6973 29.6058 37.1593 20.401 37.1593M37.0677 20.4926C37.0677 11.2878 29.6058 3.82593 20.401 3.82593M37.0677 20.4926H3.73438M20.401 37.1593C11.1963 37.1593 3.73438 29.6973 3.73438 20.4926M20.401 37.1593C24.5698 32.5953 26.939 26.6725 27.0677 20.4926C26.939 14.3127 24.5698 8.38985 20.401 3.82593M20.401 37.1593C16.2322 32.5953 13.8631 26.6725 13.7344 20.4926C13.8631 14.3127 16.2322 8.38985 20.401 3.82593M3.73438 20.4926C3.73438 11.2878 11.1963 3.82593 20.401 3.82593"
        stroke="#008934"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
